"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
function isValidPropNames(props, propNames) {
    if (!props || lodash_1.isEmpty(props))
        return false;
    return lodash_1.every(propNames, function (propName) {
        var isValid = props[propName] != null;
        if (!isValid) {
            console.warn("property \"" + propName + "\" is not valid, abort \"" + name + "\" component render");
        }
        return isValid;
    });
}
exports.default = isValidPropNames;
//# sourceMappingURL=isValidPropNames.js.map